import { Link } from 'react-router-dom';
import './FestLinks.scss';

const FestivalLinks = () => {
  return (
    <div className="festival-links">
      <h2>Festivals</h2>
      <div className="card-grid">

        <Link to="/festival/hindufest" className="card">
          <div className="img-part">
            <img src="https://i.pinimg.com/736x/17/cb/8c/17cb8c3d6fcb4eff17e71d3e58572d98.jpg" alt="Hindu Festivals" />
          </div>
          <div className="text-part">
            <h3>Hindu Festivals</h3>
            <p>All major Hindu festivals with Tithi and Vrat info.</p>
          </div>
        </Link>

        <Link to="/festival/top10" className="card">
          <div className="img-part">
            <img src="https://i.pinimg.com/736x/17/cb/8c/17cb8c3d6fcb4eff17e71d3e58572d98.jpg" alt="Top 10 Festivals" />
          </div>
          <div className="text-part">
            <h3>Top 10 Festivals</h3>
            <p>Most celebrated and loved Hindu festivals ranked.</p>
          </div>
        </Link>

        <Link to="/festival/tamil" className="card">
          <div className="img-part">
            <img src="https://i.pinimg.com/736x/17/cb/8c/17cb8c3d6fcb4eff17e71d3e58572d98.jpg" alt="Tamil Festivals" />
          </div>
          <div className="text-part">
            <h3>Tamil Festivals</h3>
            <p>Important Tamil Nadu regional festival dates.</p>
          </div>
        </Link>

        <Link to="/festival/malayalam" className="card">
          <div className="img-part">
            <img src="https://i.pinimg.com/736x/17/cb/8c/17cb8c3d6fcb4eff17e71d3e58572d98.jpg" alt="Malayalam Festivals" />
          </div>
          <div className="text-part">
            <h3>Malayalam Festivals</h3>
            <p>Onam, Vishu, and other Kerala traditional celebrations.</p>
          </div>
        </Link>

        <Link to="/festival/sankranti" className="card">
          <div className="img-part">
            <img src="https://i.pinimg.com/736x/17/cb/8c/17cb8c3d6fcb4eff17e71d3e58572d98.jpg" alt="Sankranti Festivals" />
          </div>
          <div className="text-part">
            <h3>Sankranti Festivals</h3>
            <p>All Sankranti (solar transition) details month-wise.</p>
          </div>
        </Link>

        <Link to="/festival/dashavatra" className="card">
          <div className="img-part">
            <img src="https://i.pinimg.com/736x/17/cb/8c/17cb8c3d6fcb4eff17e71d3e58572d98.jpg" alt="Dashavatra" />
          </div>
          <div className="text-part">
            <h3>Dashavatra</h3>
            <p>The 10 divine incarnations of Lord Vishnu.</p>
          </div>
        </Link>

        <Link to="/festival/navdurga" className="card">
          <div className="img-part">
            <img src="https://i.pinimg.com/736x/17/cb/8c/17cb8c3d6fcb4eff17e71d3e58572d98.jpg" alt="Navdurga" />
          </div>
          <div className="text-part">
            <h3>Navdurga</h3>
            <p>9 Forms of Goddess Durga with stories and rituals.</p>
          </div>
        </Link>

        <Link to="/festival/puja-vidhi" className="card">
          <div className="img-part">
            <img src="https://i.pinimg.com/736x/17/cb/8c/17cb8c3d6fcb4eff17e71d3e58572d98.jpg" alt="Puja Vidhi" />
          </div>
          <div className="text-part">
            <h3>Puja Vidhi</h3>
            <p>Step-by-step rituals for different pujas and vrats.</p>
          </div>
        </Link>

        <Link to="/festival/deities" className="card">
          <div className="img-part">
            <img src="https://i.pinimg.com/736x/17/cb/8c/17cb8c3d6fcb4eff17e71d3e58572d98.jpg" alt="Deities" />
          </div>
          <div className="text-part">
            <h3>Hindu Deities</h3>
            <p>List of gods and goddesses worshipped across India.</p>
          </div>
        </Link>

        <Link to="/festival/gurus-saints" className="card">
          <div className="img-part">
            <img src="https://i.pinimg.com/736x/17/cb/8c/17cb8c3d6fcb4eff17e71d3e58572d98.jpg" alt="Gurus and Saints" />
          </div>
          <div className="text-part">
            <h3>Gurus and Saints</h3>
            <p>Lives and teachings of spiritual leaders in Hinduism.</p>
          </div>
        </Link>

        <Link to="/festival/vishnu-avatar" className="card">
          <div className="img-part">
            <img src="https://i.pinimg.com/736x/17/cb/8c/17cb8c3d6fcb4eff17e71d3e58572d98.jpg" alt="24 Vishnu Avatars" />
          </div>
          <div className="text-part">
            <h3>24 Vishnu Avatars</h3>
            <p>Discover all 24 incarnations of Lord Vishnu in detail.</p>
          </div>
        </Link>

      </div>
    </div>
  );
};

export default FestivalLinks;
